import { Speedometer04 } from "@untitledui/icons";
import type { ReactNode } from "react";
import type { TableColumn } from "@/shared/components/table/table";
import { RiskBadge } from "../components/risk-badge";
import { EVENT_TYPE_UI } from "../events/events.config";
import type { EventTypeCode } from "../types/events";
import type { RankingListItem } from "../types/ranking";

export type RankingMode = "driver" | "vehicle";

function getEventTypeLabel(code: number | null | undefined): string {
	if (code === null || code === undefined) {
		return "—";
	}
	if (code >= 1 && code <= 13) {
		return EVENT_TYPE_UI[code as EventTypeCode].listTitle;
	}
	return `Tipo ${code}`;
}

function formatOdometerKm(value: number | null | undefined): string {
	if (value === null || value === undefined || Number.isNaN(value)) {
		return "—";
	}
	return `${value.toLocaleString("pt-BR")} km`;
}

export function renderRankingCell(
	item: RankingListItem,
	column: TableColumn<RankingListItem>,
	_index: number,
	mode: RankingMode
): ReactNode {
	const colId = column.id;

	switch (colId) {
		case "plate": {
			const plate = item.plate?.trim();

			if (!plate) {
				return "—";
			}

			return plate.replace(/-/g, "");
		}

		case "model":
			return item.model?.trim() || "—";

		case "predominantEventType":
			return getEventTypeLabel(item.predominantEventType);

		case "totalEvents":
			return (
				<span className="font-medium text-primary">{item.totalEvents}</span>
			);

		case "riskEvents":
			return item.riskEvents;

		case "riskPercentage":
			return <RiskBadge riskPercentage={item.riskPercentage} />;

		case "name":
			return mode === "driver" ? item.name?.trim() || "—" : "—";

		default:
			return "—";
	}
}

export function renderRankingDetailRow(item: RankingListItem): ReactNode {
	return (
		<div className="flex flex-col gap-3 py-4">
			<div className="rounded-xl border border-border-secondary bg-primary p-5">
				<h3 className="mb-3 font-medium text-primary text-sm">
					Eventos por tipo
				</h3>
				{item.eventsByType.length === 0 ? (
					<p className="text-sm text-tertiary">Nenhum evento registrado.</p>
				) : (
					<div className="columns-2 gap-x-8">
						{item.eventsByType.map((entry) => (
							<div
								className="mb-2 flex break-inside-avoid items-baseline gap-1.5 text-sm"
								key={entry.eventType}
							>
								<span className="text-tertiary">
									{getEventTypeLabel(entry.eventType)}:
								</span>
								<span className="font-medium text-primary">
									{entry.count} {entry.count === 1 ? "evento" : "eventos"}
								</span>
							</div>
						))}
					</div>
				)}
			</div>

			<div className="flex items-center gap-2 rounded-xl border border-border-secondary bg-primary p-4 text-sm">
				<Speedometer04 className="size-4 shrink-0 text-tertiary" />
				<span className="text-primary">
					Hodômetro: {formatOdometerKm(item.currentOdometer)}
				</span>
			</div>
		</div>
	);
}
